import { forwardRef } from 'react';
import { ClickAwayListener, MenuList } from '@mui/material';
import useTexts from 'features/navBar/useTexts';
import navIcons from 'features/navBar/navIcons';
import StyledNavSubList from './style';
import NavSubListMenu from './navSubListMenu';
import NavSubListLink from './navSubListLink';
import DocumentationNavLink from './documentationNavLink';
import { DOCUMENTATION_RB_TOKEN } from './documentationNavLink/constants';

const getNavListChildComponent = (item) =>
  ({
    menu: {
      NavSubListItem: item.subMenuList.length === 0 ? null : NavSubListMenu,
    },
    link: {
      NavSubListItem: item.rbToken === DOCUMENTATION_RB_TOKEN ? DocumentationNavLink : NavSubListLink,
    },
  }[item.type]);

const NavSubList = forwardRef(({ expanded, title, sublist, closeMenu }, ref) => {
  const { getNavItemTitle } = useTexts();
  const getColumnCount = () => {
    const MAX_COLUMN_ITEMS = 16;
    const itemCount = sublist.flatMap((section) => section.subMenuList).length + sublist.length;
    return Math.ceil(itemCount / MAX_COLUMN_ITEMS);
  };
  return (
    <StyledNavSubList expanded={expanded} columnCount={getColumnCount()} className={`${title}-menu`} ref={ref}>
      <ClickAwayListener onClickAway={closeMenu}>
        <MenuList className="submenu">
          {sublist.map((item) => {
            const icon = navIcons[item.id];
            const title = getNavItemTitle(item.rbToken);
            const { NavSubListItem } = getNavListChildComponent(item);

            return (
              NavSubListItem && (
                <NavSubListItem
                  icon={icon}
                  title={title}
                  url={item.url}
                  menu={item}
                  closeMenu={closeMenu}
                  isOpenInNewTab={item.isOpenInNewTab}
                />
              )
            );
          })}
        </MenuList>
      </ClickAwayListener>
    </StyledNavSubList>
  );
});

export default NavSubList;
